import { openCrisp } from '@/helpers';
import { Banner, BannerProps, Button, Card, Collapsible, IconSource } from '@shopify/polaris';
import { memo } from 'react';
import RegularText from '../RegularText';

interface IProps {
  title?: string;
  isVisible: boolean;
  children: React.ReactNode;
  isNotInCard?: boolean;
  hideContact?: boolean;
  icon?: IconSource;
  removeMargin?: boolean;
  onDismiss?: () => void;
  tone?: BannerProps['tone'];
}

const WarningBanner = ({ ...props }: IProps) => {
  const content = (
    <Banner title={props.title} tone={props.tone || 'info'} icon={props.icon} onDismiss={props.onDismiss}>
      <RegularText>{props.children}</RegularText>
      {props.hideContact ? null : (
        <div className="mt-8">
          <Button onClick={openCrisp}>Contact support</Button>
        </div>
      )}
    </Banner>
  );
  return (
    <div
      style={{
        marginBottom: props.isVisible && !props.removeMargin ? 16 : 0,
      }}
    >
      <Collapsible open={props.isVisible} id="basic-collapsible" transition={{ duration: '500ms' }} expandOnPrint>
        {props.isNotInCard ? <Card>{content}</Card> : content}
      </Collapsible>
    </div>
  );
};

export default memo(WarningBanner);
